import React, { useEffect, useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { useLang } from '../context/LanguageContext';
import { HERO_CAROUSEL } from '../mock';

export default function Hero() {
  const { t } = useLang();
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const id = setInterval(() => {
      setIndex((p) => (p + 1) % HERO_CAROUSEL.length);
    }, 5500);
    return () => clearInterval(id);
  }, []);

  const scrollTo = (href) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="home" className="relative h-screen min-h-[640px] w-full overflow-hidden">
      {/* Background carousel (crossfade) */}
      <div className="absolute inset-0">
        {HERO_CAROUSEL.map((src, i) => (
          <div
            key={i}
            className={`absolute inset-0 transition-opacity duration-[1500ms] ease-in-out ${
              i === index ? 'opacity-100' : 'opacity-0'
            }`}
          >
            <img
              src={src}
              alt="Dintorni di Caltanissetta, Sicilia"
              className={`w-full h-full object-cover ${i === index ? 'animate-kenburns' : ''}`}
            />
          </div>
        ))}
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/25 to-[#2A2420]/75" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#2A2420]/60 to-transparent" />
      </div>

      {/* Content */}
      <div className="relative z-10 h-full flex flex-col items-center justify-center text-center px-6">
        <p className="font-body text-[#E7DAC4] tracking-[0.45em] uppercase text-xs md:text-sm mb-6 animate-fade-up" style={{ animationDelay: '0.1s' }}>
          {t('hero.kicker')}
        </p>
        <h1 className="font-display text-white leading-[0.9] animate-fade-up" style={{ animationDelay: '0.25s' }}>
          <span className="block text-6xl md:text-8xl lg:text-9xl font-500">{t('hero.title')}</span>
          <span className="block text-2xl md:text-4xl tracking-[0.5em] uppercase mt-4 text-[#D69A4C] font-400">{t('hero.title2')}</span>
        </h1>
        <p className="font-body text-white/85 text-base md:text-xl max-w-2xl mt-8 leading-relaxed animate-fade-up" style={{ animationDelay: '0.45s' }}>
          {t('hero.subtitle')}
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-4 mt-10 animate-fade-up" style={{ animationDelay: '0.6s' }}>
          <button
            onClick={() => scrollTo('#camere')}
            className="font-body tracking-wide px-9 py-3.5 rounded-full bg-[#B5603A] text-white hover:bg-[#8F4A2C] transition-all duration-300 hover:shadow-xl hover:-translate-y-0.5"
          >
            {t('hero.cta1')}
          </button>
          <button
            onClick={() => scrollTo('#contatti')}
            className="font-body tracking-wide px-9 py-3.5 rounded-full border border-white/70 text-white hover:bg-white hover:text-[#2A2420] transition-all duration-300"
          >
            {t('hero.cta2')}
          </button>
        </div>
      </div>

      {/* Carousel dots */}
      <div className="absolute bottom-24 md:bottom-20 left-1/2 -translate-x-1/2 z-10 flex items-center gap-2.5">
        {HERO_CAROUSEL.map((_, i) => (
          <button
            key={i}
            onClick={() => setIndex(i)}
            aria-label={`slide ${i + 1}`}
            className={`h-1.5 rounded-full transition-all duration-500 ${
              i === index ? 'w-8 bg-[#D69A4C]' : 'w-1.5 bg-white/50 hover:bg-white/80'
            }`}
          />
        ))}
      </div>

      {/* Scroll hint */}
      <button
        onClick={() => scrollTo('#benvenuti')}
        className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-2 text-white/80 hover:text-white transition-colors"
      >
        <span className="font-body text-[10px] tracking-[0.35em] uppercase">{t('hero.scroll')}</span>
        <ChevronDown className="w-5 h-5 animate-scroll-hint" />
      </button>
    </section>
  );
}
